import { useNavigate, useParams, useLocation } from "react-router-dom";
import "./index.css";

// Importar fonte Poppins se ainda não estiver
if (typeof document !== 'undefined') {
  const link = document.createElement('link');
  link.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap';
  link.rel = 'stylesheet';
  if (!document.head.querySelector('link[href*="Poppins"]')) {
    document.head.appendChild(link);
  }
}

export function BookingHeader() {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const location = useLocation();

  // Verificar se está na página de consulta
  const isSearchPage = location.pathname.includes('/booking/search');

  const handleButtonClick = () => {
    if (isSearchPage) {
      // Se está na página de consulta, volta para reservar
      navigate(`/${pluginspace_id}/booking`);
    } else {
      // Se está em outra página, vai para consulta
      navigate(`/${pluginspace_id}/booking/search`);
    }
  };

  return (
    <header 
      style={{
        background: "linear-gradient(135deg, rgba(33, 150, 243, 0.08) 0%, rgba(30, 136, 229, 0.05) 50%, rgba(25, 118, 210, 0.06) 100%)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        borderBottom: "1px solid rgba(33, 150, 243, 0.2)",
        boxShadow: "0 4px 24px rgba(33, 150, 243, 0.12)",
        position: "sticky" as const,
        top: 0,
        zIndex: 1000,
        width: "100%"
      }}
    >
      <div style={{
        margin: "0",
        padding: "16px 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start"
      }}>
        {/* Logo e Nome - Esquerda */}
        <div 
          onClick={() => navigate(`/${pluginspace_id}/booking`)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            marginRight: "16px"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.02)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          {/* Ícone com gradiente */}
          <div style={{
            position: "relative" as const,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <div style={{
              position: "absolute",
              inset: 0,
              background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
              borderRadius: "16px",
              filter: "blur(12px)",
              opacity: 0.4
            }} />
            <div style={{
              position: "relative",
              padding: "10px",
              borderRadius: "16px",
              background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
              boxShadow: "0 4px 12px rgba(99, 102, 241, 0.3)"
            }}>
              <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: "block" }}
              >
                <path 
                  d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
                <path 
                  d="M16 2V6M8 2V6M3 10H21" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
                <path 
                  d="M12 15C13.1046 15 14 14.1046 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15Z" 
                  fill="white"
                />
              </svg>
            </div>
          </div>

          {/* Nome */}
          <div>
            <h1 style={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: "24px",
              fontWeight: "700",
              color: "#2d3436",
              letterSpacing: "-0.5px",
              lineHeight: 1,
              margin: 0
            }}>
              Reserva<span style={{
                background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text"
              }}>Fácil</span>
            </h1>
          </div>
        </div>

        {/* Botão Consulta/Reservar - Direita */}
        <button
          onClick={handleButtonClick}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(33, 150, 243, 0.3)";
            e.currentTarget.style.background = "linear-gradient(135deg, rgba(33, 150, 243, 0.15) 0%, rgba(30, 136, 229, 0.1) 100%)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(33, 150, 243, 0.15)";
            e.currentTarget.style.background = "transparent";
          }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "6px 12px",
            background: "transparent",
            border: "1px solid rgba(33, 150, 243, 0.3)",
            borderRadius: "8px",
            color: "#2196F3",
            fontFamily: "'Poppins', sans-serif",
            fontSize: "13px",
            fontWeight: "600",
            cursor: "pointer",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            boxShadow: "0 2px 8px rgba(33, 150, 243, 0.15)",
            outline: "none",
            marginLeft: "auto",
            marginRight: "20px"
          }}
        >
          {isSearchPage ? (
            <>
              {/* Ícone de Calendário */}
              <svg 
                width="14" 
                height="14" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: "block" }}
              >
                <path
                  d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Reservar
            </>
          ) : (
            <>
              {/* Ícone de Lupa */}
              <svg 
                width="14" 
                height="14" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: "block" }}
              >
                <circle 
                  cx="11" 
                  cy="11" 
                  r="8" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
                <path 
                  d="M21 21L16.65 16.65" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
              Consulta
            </>
          )}
        </button>
      </div>
    </header>
  );
}
